<template>
  <div>
    <!-- 上方主体 定制服务-企业定制服务 -->
    <div
      class="container_top"
      id="topCont"
      ref="topCont"
      @mouseover="barNum = 0"
    >
      <div class="topTitCont">
        <img
          style="width: 100%; display: block"
          :src="contTopInfo.picUrl"
          alt=""
        />
        <!-- flgId == 1
            ? 'https://oss.jingshucloud.com/gw-bucket/4605ac72-21d5-4f50-a50f-5ba11edc837d.png'
            : 'https://oss.jingshucloud.com/gw-bucket/d9fa1cf6-06ec-442d-9cd9-74d33d61c78f.png' -->
        <div class="cont_topTil">{{ contTopInfo.name }}</div>
        <div class="cont_topShad">
          {{ contTopInfo.nameEn }}
        </div>
      </div>
      <!-- 头部tap -->
      <div class="tapCont">
        <div class="tapAll">
          <div class="tapTxt">
            <div
              class="tapOne"
              :class="tapFlg == 1 ? 'colr' : ''"
              @click="tapClic(1)"
            >
              软件定制
            </div>
            <div
              class="tapOne"
              :class="tapFlg == 2 ? 'colr' : ''"
              @click="tapClic(2)"
            >
              硬件定制
            </div>
          </div>
          <div class="memoryTap">
            <img
              @click="goHome('99')"
              style="margin: 0 10px; cursor: pointer"
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
              alt=""
            />
            <span style="cursor: pointer" @click="goHome('4')">定制服务</span>
            <img
              src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
              alt=""
            />
            <span style="cursor: pointer">{{ contTopInfo.name }}</span>
          </div>
        </div>
        <div
          :class="
            tapHomeFlg ? 'tapHome' : tapNum == 1 ? 'tapPackUp' : 'tapPack'
          "
        >
          <div class="memoryTapCont">
            <div class="tapTxt">
              <div
                class="tapOne"
                :class="tapFlg == 1 ? 'colr' : ''"
                @click="tapClic(1)"
              >
                软件定制
              </div>
              <div
                class="tapOne"
                :class="tapFlg == 2 ? 'colr' : ''"
                @click="tapClic(2)"
              >
                硬件定制
              </div>
            </div>
            <div class="memoryTap">
              <img
                @click="goHome('99')"
                style="margin: 0 10px; cursor: pointer"
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/j898yobzmr5xf0bwf7zv.png"
                alt=""
              />
              <span style="cursor: pointer" @click="goHome('4')">定制服务</span>
              <img
                src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/zkx9jcs2ut083xtg5piu.png"
                alt=""
              />
              <span style="cursor: pointer">私人定制</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cust_content" id="overviewApp" ref="custom">
        <div class="customCont">
          <div v-show="tapFlg == 1">
            <div
              v-for="(item, index) in infoRjAll"
              :key="index"
              class="customCard"
            >
              <div
                class="customCardTop"
                @click="item.openFlg = !item.openFlg"
                :class="item.openFlg ? 'noneBorder' : ''"
              >
                <div class="customCard_left">
                  <img :src="item.imgUrl" alt="" />
                  <div>
                    {{ item.name }}
                  </div>
                </div>

                <i
                  :class="
                    item.openFlg ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                  "
                ></i>
              </div>
              <div v-show="item.openFlg">
                <el-checkbox-group
                  v-model="item.fromValue"
                  @change="customRjChange"
                >
                  <div
                    class="checkCont"
                    v-for="(item1, index1) in item.children"
                    :key="index1"
                    :class="index1 % 2 == 0 ? 'checkbag' : ''"
                  >
                    <el-checkbox :label="item1.id">
                      <div :class="item1.text ? 'textCont' : ''">
                        <div class="checkBlack">{{ item1.name }}</div>
                        <div class="checkGray">{{ item1.remarks }}</div>
                      </div>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div v-show="tapFlg == 2">
            <div class="topPhone">
              <div
                class="topPhoneCard"
                v-for="(item, index) in infoYjAll"
                :class="item.openFlg ? 'befo' : ''"
                @click="yjTab(index)"
                :key="index"
              >
                <div class="phoneTxt">{{ item.name }}</div>
                <img
                  v-if="item.name"
                  :src="item.customImgs[item.imgNum].imgUrl"
                  alt=""
                />
                <div class="phoneBut">
                  <div
                    v-for="(item1, index1) in item.customImgs"
                    :key="index1"
                    class="buts"
                    :class="item.imgNum == index1 ? 'butBox' : ''"
                    @click="phoneImgClick(index, index1)"
                    :style="{ 'background-color': item1.imgColor }"
                  ></div>
                  <!-- <div class="butBot" @click="phoneImgClick(index, 1)"></div> -->
                </div>
              </div>
              <!-- <div class="topPhoneCard">
              <div class="phoneTxt">安全手机</div>
              <img
                src="https://oss.jingshucloud.com/gw-bucket/016f9267-d719-4597-978e-b0959e2bb35c.png"
                alt=""
              />
              
              <div class="phoneBut">
                <div class="buts" @click="phoneImgClick(1)"></div>
                <div class="butBot" @click="phoneImgClick(2)"></div>
              </div>
            </div>
            <div class="topPhoneCard">
              <div class="phoneTxt">5G天通卫星手机</div>
              <img
                src="https://oss.jingshucloud.com/gw-bucket/016f9267-d719-4597-978e-b0959e2bb35c.png"
                alt=""
              />
              <div class="phoneBut">
                <div class="buts"></div>
                <div class="butBot"></div>
              </div>
            </div> -->
            </div>
            <div v-for="(item, index) in infoYjAll" :key="index">
              <div class="customCard" v-if="yjTabNum == index">
                <!-- <div
              class="customCardTop"
              :class="item.openFlg ? 'noneBorder' : ''"
            >
              <div class="customCard_left">
                <img :src="item.img" alt="" />
                <div>
                  {{ item.tit }}
                </div>
              </div>

              <i
                :class="
                  item.openFlg ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div> -->
                <div v-show="item.openFlg && yjTabNum == index">
                  <el-checkbox-group
                    v-model="item.fromValue"
                    @change="customYjChange"
                  >
                    <div
                      class="checkCont"
                      v-for="(item1, index1) in item.hardwareCustomList"
                      :key="index1"
                      :class="index1 % 2 == 0 ? 'checkbag' : ''"
                    >
                      <el-checkbox :label="item1.id">
                        <div :class="item1.text ? 'textCont' : ''">
                          <div class="checkBlack">{{ item1.name }}</div>
                          <div class="checkGray">{{ item1.remarks }}</div>
                        </div>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="customBotTit">您已选择的定制内容</div>
            <div class="pendingSystem">
              <div
                class="designateCustom"
                v-show="designateRjArr.length > 0 || designateYjArr.length > 0"
              >
                <div class="rjCont">
                  <div class="rjTit">软件定制</div>
                  <div class="yjNull" v-if="!designateRjArr.length > 0">
                    <div class="yjTxt">您尚未选择定制内容～</div>
                    <div class="yjBtn" @click="tapClic(1)">去选择</div>
                  </div>
                  <div
                    class="designateSingle"
                    v-for="(item, index) in designateRjArr"
                    :key="index"
                  >
                    <div>{{ item.tit }}</div>
                    <div>{{ item.txt }}</div>
                  </div>
                </div>
                <div class="rjCont">
                  <div class="rjTit">硬件定制</div>
                  <div class="yjNull" v-if="!designateYjArr.length > 0">
                    <div class="yjTxt">您尚未选择定制内容～</div>
                    <div class="yjBtn" @click="tapClic(2)">去选择</div>
                  </div>
                  <div
                    class="designateSingle"
                    v-for="(item, index) in designateYjArr"
                    :key="index"
                  >
                    <div>{{ item.tit }}</div>
                    <div>{{ item.txt }}</div>
                  </div>
                </div>
              </div>
              <div
                v-show="
                  designateRjArr.length == 0 && designateYjArr.length == 0
                "
              >
                <img
                  src="https://oss.jingshucloud.com/gw-bucket/3bf709d0-2dac-4ddb-a1f9-ae2d8378d48f.png"
                  alt=""
                />
                <div class="tipTxt">您尚未选择定制内容</div>
              </div>
            </div>
          </div>
          <div class="customBotTit">个人信息</div>
          <div class="customBot">
            <el-form :model="loginForm" :rules="rules" ref="loginForm">
              <div class="inputCont">
                <div>
                  <el-form-item label="姓名" prop="name">
                    <el-input
                      style="width: 480px"
                      placeholder="请输入姓名"
                      v-model="loginForm.name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱" :prop="flgId == 1 ? 'eMail' : ''">
                    <el-input
                      style="width: 480px"
                      placeholder="请输入邮箱"
                      v-model="loginForm.eMail"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单位详细地址"
                    :prop="flgId == 1 ? '' : 'companyAddress'"
                  >
                    <el-input
                      style="width: 480px"
                      placeholder="请输入单位详细地址"
                      v-model="loginForm.companyAddress"
                    ></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="电话" prop="tel">
                    <el-input
                      style="width: 480px"
                      placeholder="请输入电话"
                      v-model="loginForm.tel"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单位名称"
                    :prop="flgId == 1 ? '' : 'companyName'"
                  >
                    <el-input
                      style="width: 480px"
                      placeholder="请输入单位名称"
                      v-model="loginForm.companyName"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="flgId == 2" label="职务" prop="positions">
                    <el-input
                      style="width: 480px"
                      placeholder="请输入职务"
                      v-model="loginForm.positions"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <el-form-item label="附言">
                <el-input
                  style="max-width: 1200px"
                  type="textarea"
                  :rows="8"
                  placeholder="请输入内容..."
                  v-model="loginForm.positions"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div style="display: flex; align-items: center">
                  <el-checkbox v-model="agreementRadio"></el-checkbox>
                  <div style="margin-left: 10px">
                    我已阅读并同意<a style="color: #04758e" href=""
                      >《京数服务协议条款》</a
                    >
                  </div>
                </div>
              </el-form-item>

              <el-form-item>
                <el-button
                  class="submit_btn"
                  type="primary"
                  @click="submitForm('loginForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div id="mobile">
      <customizeEnterprise
        :navBar="navBar"
        :rules="rules"
        :flgId="flgId"
        :contTopInfo="contTopInfo"
        :infoYjAll="infoYjAll"
        :topPhoneArr="topPhoneArr"
        :infoRjAll="infoRjAll"
      />
    </div>
  </div>
</template>

<script>
import customizeEnterprise from "@/views/mobile/customizeService/customizeEnterprise.vue";
import { getCustomList, addCustomDemand } from "@/api/index";
export default {
  components: { customizeEnterprise },
  data() {
    var checkPhone = (rule, value, callback) => {
      // 手机号验证
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      tapHomeFlg: false,
      tapNum: 0,
      tapFlg: "1",
      flgId: "0",
      customizeId: 0,
      yjTabNum: 0,
      contTopInfo: {},
      infoRjAll: [
        {
          openFlg: false,
          tit: "个性化",
          img: "https://oss.jingshucloud.com/gw-bucket/6fef8391-76f6-49be-ab98-50e87ee4ddc9.png",
          fromValue: [],
          formArr: [
            { label: "自定义开机logo，动画", value: "0" },
            { label: "壁纸及主题UI定制", value: "1" },
            { label: "自定义桌面布局", value: "2" },
            { label: "预装专属应用", value: "3" },

            { label: "资源预制，铃声，音视频，图片", value: "4" },
            {
              label: "自定义侧边按钮，实现单机，双击或多次点击事件",
              value: "5",
            },
            { label: "负一屏定制信息流", value: "6" },
          ],
        },
        {
          openFlg: false,
          tit: "安全",
          img: "https://oss.jingshucloud.com/gw-bucket/415f0f80-d6b5-4086-9e93-670bdb917460.png",
          fromValue: [],
          formArr: [
            { label: "限制获取 Root 与刷机", value: "0" },
            { label: "锁定设备，设备定位，数据擦除", value: "1" },
            { label: "应用安全加固", value: "2" },
            { label: "数据安全加密(通话，短信)", value: "3" },
            { label: "通话短信功能控制", value: "4" },
            {
              label: "自定义侧边按钮，实现单机，双击或多次点击事件",
              value: "5",
            },
            { label: "客户号码安全，自动识别来电号码", value: "6" },
            { label: "根据规则监控设备状态，发现异常报警", value: "7" },
            {
              label:
                "基于安全芯片提供硬件级别的密钥管理、身份鉴别、数据加解密服务",
              value: "8",
            },
          ],
        },
        {
          openFlg: false,
          tit: "MDM定制能力",
          img: "https://oss.jingshucloud.com/gw-bucket/15d707f8-fe7a-4074-8e51-42f7c06a509f.png",
          fromValue: [],
          formArr: [
            { label: "远程静默安装与卸载", value: "0" },
            { label: "应用安装和运行白名单", value: "1" },
            {
              label: "终端管控",
              value: "2",
              text: "根据需要开启禁用网络/麦克风、相机、蓝牙、GPS、Wifi、USB等功能",
            },
          ],
        },
        {
          openFlg: false,
          tit: "特色功能",
          img: "https://oss.jingshucloud.com/gw-bucket/5d8bf035-86ba-419b-b5e0-380fd4a9c2e3.png",
          fromValue: [],
          formArr: [
            { label: "卫星通信", value: "0" },
            { label: "量子通话", value: "1" },
            { label: "提供虚拟联系人/短信/通话记录、虚拟位置", value: "2" },
            { label: "双系统", value: "3", text: "工作、个人隐私系统" },
          ],
        },
      ],
      designateRjArr: [],

      topPhoneArr: [
        {
          flg: true,
          tit: "高安全手机",
          img: [
            "https://oss.jingshucloud.com/gw-bucket/016f9267-d719-4597-978e-b0959e2bb35c.png",
            "https://oss.jingshucloud.com/gw-bucket/030147e1-c79d-4943-a546-6b4ca6d262e7.png",
          ],
          imgNum: 0,
          colorBut: ["#6fffff", "#000"],
        },
        {
          flg: false,
          tit: "安全手机",
          img: [
            "https://oss.jingshucloud.com/gw-bucket/16fca10c-1514-4648-8410-46af018be191.png",
            "https://oss.jingshucloud.com/gw-bucket/2b09701f-aded-47ef-80b3-d048aa7dc073.png",
          ],
          imgNum: 0,
          colorBut: ["#E8E8E8", "#000"],
        },
        {
          flg: false,
          tit: "5G天通卫星手机",
          img: [
            "https://oss.jingshucloud.com/gw-bucket/b8398e45-bae6-45dc-904a-bef14202ed90.png",
            "https://oss.jingshucloud.com/gw-bucket/aa53aba3-9081-4a82-84cd-7f3c10849e87.png",
          ],
          imgNum: 0,
          colorBut: ["#E8E8E8", "#000"],
        },
      ],
      infoYjAll: [
        {
          openFlg: true,
          tit: "高安全手机",
          img: "https://oss.jingshucloud.com/gw-bucket/0012a617-fdca-41d7-94fa-f7e158101145.png",
          fromValue: [],
          formArr: [
            { label: "logo", value: "0", text: "机身、充电器、彩盒、说明书等" },
            {
              label: "摄像头",
              value: "1",
              text: "镜片可丝印文字、logo、简单图案",
            },
            { label: "颜色", value: "2", text: "机身颜色、机身布局颜色" },
            { label: "电池盖", value: "3", text: "材质、颜色、部分工艺" },
            { label: "彩盒", value: "4", text: "定制彩盒设计及配件、logo" },
            {
              label: "保护套",
              value: "5",
              text: "手机保护套材质、图案、logo丝印等",
            },
          ],
        },
        {
          openFlg: true,
          tit: "安全手机",
          img: "https://oss.jingshucloud.com/gw-bucket/dff80418-d992-4540-845e-5d020e5adf27.png",
          fromValue: [],
          formArr: [
            { label: "logo", value: "0", text: "机身、充电器、彩盒、说明书等" },
            {
              label: "摄像头",
              value: "1",
              text: "镜片可丝印文字、logo、简单图案",
            },
            { label: "颜色", value: "2", text: "机身颜色、机身布局颜色" },
            { label: "电池盖", value: "3", text: "材质、颜色、部分工艺" },
            { label: "彩盒", value: "4", text: "定制彩盒设计及配件、logo" },
            {
              label: "保护套",
              value: "5",
              text: "手机保护套材质、图案、logo丝印等",
            },
          ],
        },
        {
          openFlg: true,
          tit: "5G天通卫星手机",
          img: "https://oss.jingshucloud.com/gw-bucket/1cfec844-6e34-4395-b8d9-1011096ef808.png",
          fromValue: [],
          formArr: [
            { label: "logo", value: "0", text: "机身、充电器、彩盒、说明书等" },
            {
              label: "摄像头",
              value: "1",
              text: "镜片可丝印文字、logo、简单图案",
            },
            { label: "颜色", value: "2", text: "机身颜色、机身布局颜色" },
            { label: "电池盖", value: "3", text: "材质、颜色、部分工艺" },
            { label: "彩盒", value: "4", text: "定制彩盒设计及配件、logo" },
            {
              label: "保护套",
              value: "5",
              text: "手机保护套材质、图案、logo丝印等",
            },
          ],
        },
      ],
      designateYjArr: [],
      loginForm: {
        name: "",
        eMail: "",
        tel: "",
        companyName: "",
        positions: "",
        positions: "",
        companyAddress: "",
        demandContent: "",
        customId: localStorage.getItem("customizeId"),
      },

      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        eMail: [{ required: true, message: "请输入您的邮箱", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入您的单位", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入您的详细地址", trigger: "blur" },
        ],
        positions: [
          { required: true, message: "请输入您的职务", trigger: "blur" },
        ],
      },
      agreementRadio: "",
      navBar: [
        {
          icon: "icon-home",
          path: "/customizeHome",
          isRutern: false,
          name: "定制服务",
          params: {},
          query: {},
        },
        {
          icon: "icon-right-1-copy",
          path: "",
          isRutern: false,
          name: "私人定制",
          params: {},
          query: {},
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {},
  created() {
    let that = this;
    // console.log(this.$route.params, "测试数据");
    // if (this.$route.params.flgId) {
    //   // localStorage.setItem('customizeflgId', this.$route.params.flgId);

    //   console.log(
    //     localStorage.getItem("customizeflgId"),
    //     "定制标识",
    //     localStorage.getItem("customizeId")
    //   );
    // }
    // if (this.$route.params.id) {
    //   localStorage.setItem('customizeId', this.$route.params.id);
    // }

    this.flgId = localStorage.getItem("customizeflgId");
    this.customizeId = localStorage.getItem("customizeId");
    getCustomList({ id: this.customizeId, type: 0 }).then((res) => {
      this.contTopInfo = res.data.data;
      this.navBar[1].name = this.contTopInfo.name;
      if (res.data.data.list) {
        this.infoRjAll = this.handleTree(res.data.data.list, "id");
      }
    });
    getCustomList({ id: this.customizeId, type: 1 }).then((res) => {
      if (res.data.data.customImgs.length > 0) {
        this.infoYjAll = res.data.data.customImgs;
        this.infoYjAll[0].openFlg = true;
      }

      console.log(res, "硬件定制数据", this.infoYjAll);
    });
  },
  methods: {
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || "id",
        parentId: parentId || "parentId",
        childrenList: children || "children",
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }
      return tree;
    },
    yjTab(row) {
      this.infoYjAll.forEach((item, index) => {
        if (index == row) {
          item.openFlg = true;
        } else {
          item.openFlg = false;
        }
      });
      this.yjTabNum = row;
    },
    submitForm(formName) {
      console.log("测试", this.loginForm, this.infoRjAll, this.infoYjAll);
      let demandContent = [];

      if (this.designateYjArr.length > 0) {
        demandContent = demandContent.concat(
          this.designateYjArr[0].value,
          this.designateRjArr[0].value
        );
        this.loginForm.demandContent = demandContent.join(",");
      }
      if (!this.loginForm.demandContent) {
        this.$message({
          type: "warning",
          message: "请选择您的定制内容",
          offset: 110,
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          addCustomDemand(this.loginForm).then((res) => {
            console.log(res);
            this.infoRjAll.forEach((item) => {
              item.fromValue = [];
            });
            this.infoYjAll.forEach((item) => {
              item.fromValue = [];
            });
            this.designateYjArr[0].value = [];
            this.designateRjArr[0].value = [];
            this.loginForm = {
              name: "",
              eMail: "",
              tel: "",
              companyName: "",
              positions: "",
              positions: "",
              companyAddress: "",
              demandContent: "",
            };
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    register() {
      console.log(this.loginForm, "看啊");
      this.$refs["loginForm"].validate(async (valid) => {
        if (valid) {
        }
      });
    },
    tapClic(row) {
      this.tapFlg = row;
      document
        .getElementById("overviewApp")
        .scrollIntoView({ behavior: "smooth" });
    },
    goHome(row, id) {
      this.$emit("switchflg", "0", row);
      if (row == "99") {
        this.$router.push({
          name: "myHome",
          params: {},
        });
      }
      if (row == "4") {
        this.$router.push({
          name: "customizeHome",
          params: {},
        });
      }
    },
    customRjChange(row) {
      // console.log(this.infoRjAll, row, "测试数据");
      this.designateRjArr = [];
      this.infoRjAll.forEach((element) => {
        let num =
          element.fromValue.length + "/" + element.children.length + "项";
        if (element.fromValue.length == element.children.length) {
          num = "全部";
        }
        if (element.fromValue.length > 0) {
          this.designateRjArr.push({
            tit: element.name,
            txt: num,
            value: element.fromValue,
          });
        }
      });
    },
    customYjChange(row) {
      console.log(this.infoYjAll, row, "测试数据");
      this.designateYjArr = [];
      this.infoYjAll.forEach((element) => {
        let num =
          element.fromValue.length +
          "/" +
          element.hardwareCustomList.length +
          "项";
        if (element.fromValue.length == element.hardwareCustomList.length) {
          num = "全部";
        }
        if (element.fromValue.length > 0) {
          this.designateYjArr.push({
            tit: element.name,
            txt: num,
            value: element.fromValue,
          });
        }
        console.log(this.designateYjArr);
      });
    },
    phoneImgClick(row, num) {
      this.infoYjAll.forEach((item, index) => {
        if (row == index) {
          item.imgNum = num;
        }
      });
    },
    handleScroll() {
      if (this.$refs.custom && this.$refs.custom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.custom.offsetTop,
        //   this.switchNum,
        //   document.body.scrollTop
        // );

        if (window.scrollY > 750) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        this.$emit("switchflg", "0");
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  color: #000 !important;
}
.container_top {
  width: 100%;
  margin-bottom: -100px;
  background: #f7f8fa;
  .topTitCont {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    opacity: 0.8;
    position: absolute;
    bottom: 46%;
    //left: 13%;
    font-size: 20px;
    color: white;
  }
  // 头部tap
  .tapCont {
    position: relative;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    .tapAll {
      width: 100%;
      max-width: 1200px;
      margin: 0px auto;
      height: 90px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tapTxt {
      display: flex;
      align-items: center;
      margin-left: -20px;
    }
    .tapOne {
      cursor: pointer;
      font-size: 20px;
      margin: 20px;
    }
    .colr {
      // background: linear-gradient(360deg, #003365 0%, #048799 100%);
      position: relative;
      color: #048799;
    }
    .colr::before {
      content: "";
      height: 3px;
      background: #048799;
      position: absolute;
      top: 44px;
      width: 100%;
    }
    @keyframes arise {
      0% {
        top: -80px;
      }
      100% {
        top: 0px;
      }
    }
    .tapHome {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0px;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 103px;
      animation: arise 0.5s ease-out;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .tapPackUp {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: -130px;
      width: 100%;
      animation: packUp 0.5s ease-out;
    }
    @keyframes packUp {
      0% {
        position: fixed;
        z-index: 9999;
        width: 100%;
        background: white;
        height: 80px;
        top: 0px;
      }
      100% {
        position: fixed;
        z-index: 9999;
        width: 100%;
        background: white;
        height: 80px;
        top: -80px;
      }
    }
    .tapPack {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: -130px;
    }
    .memoryTapCont {
      width: 100%;
      max-width: 1200px;
      display: flex;
      justify-content: space-between;
    }
    .memoryTap {
      display: flex;
      justify-content: end;
      align-items: center;
    }
    .memoryTap img {
      width: 20px;
    }
  }
  .cust_content {
    display: flex;
    justify-content: center;
    align-items: center;
    .customCont {
      margin: 60px;
      // background: #fff;
      width: 100%;
      max-width: 1200px;
      .topPhone {
        display: flex;
        align-items: center;
        .topPhoneCard {
          position: relative;
          width: 380px;
          height: 310px;
          margin-right: 30px;
          background-color: #fff;
          display: flex;
          align-items: center;
          flex-direction: column;
          img {
            width: 170px;
            height: 170px;
          }
        }
        .befo::before {
          content: "";
          height: 6px;
          background: #048799;
          position: absolute;
          top: 0px;
          width: 100%;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;
        }
        .topPhoneCard:last-child {
          margin-right: 0px;
        }
        .phoneTxt {
          font-size: 24px;
          font-weight: 500;
          color: #151a23;
          margin: 32px 0 16px 0;
        }
        .phoneBut {
          margin-top: 14px;
          display: flex;
          align-items: center;
        }
        .buts {
          width: 12px;
          height: 12px;
          margin-right: 10px;
          border-radius: 50%;
          cursor: pointer;
          // background: linear-gradient(
          //   180deg,
          //   #d1ffff 0%,
          //   #6fffff 52%,
          //   #c6c0fe 100%
          // );

          // background-color: #6fffff;
        }
        .butBox {
          box-shadow: 0px 0px 0px 3px rgba(103, 142, 4, 0.1);
        }
        .butBot {
          width: 12px;
          height: 12px;
          background: #000;
          border-radius: 50%;
        }
      }
      .customCard {
        background-color: #fff;
        padding: 40px 36px;
        margin: 32px 0;
        .customCardTop {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            font-size: 24px;
          }
        }

        .noneBorder {
          padding-bottom: 32px;
          border-bottom: 1px solid #dce0ea;
          margin-bottom: 30px;
        }
        .customCard_left {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 48px;
            height: 48px;
          }
          div {
            font-size: 24px;
            font-weight: bold;
            color: #151a23;
            margin-left: 6px;
          }
        }
      }
      .checkCont {
        height: 40px;
        // width: 420px;
        padding: 25px 40px;
        // margin: 20px;
        display: flex;
        align-items: center;
      }
      .checkbag {
        background: #f9fafc;
      }
      .textCont {
        position: absolute;
        top: -10px;
        left: 11px;
      }
      .checkBlack {
        font-size: 20px;
        color: #151a23;
      }
      .checkGray {
        margin-top: 10px;
        font-size: 14px;
        color: #999;
      }
      .pendingSystem {
        margin: 40px 0 60px 0;
        padding: 30px 0;
        // height: 300px;
        background: #ffffff;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .designateCustom {
          display: flex;
          justify-content: space-between;
          .rjCont {
            width: 520px;
            margin: 0 40px;
          }
          .yjNull {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
          }
          .yjTxt {
            font-weight: 400;
            font-size: 16px;
            color: #999999;
          }
          .yjBtn {
            width: 125px;
            height: 40px;
            border: 1px solid #04758e;
            margin-top: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #04758e;
          }
          .rjTit {
            font-size: 20px;
            font-weight: bold;
            color: #151a23;
            margin-bottom: 30px;
          }
          .designateSingle {
            display: flex;
            justify-content: space-between;
            background: #f9fafc;
            padding: 27px 40px;
          }
        }

        .tipTxt {
          margin-top: 35px;
          color: #999999;
          text-align: center;
        }
        img {
          width: 213px;
          height: 117px;
        }
      }
    }
    .inputCont {
      display: flex;
      justify-content: space-between;
    }
    .customCont_top {
      display: flex;
      justify-content: space-between;
      padding: 45px 70px 0px;
    }
    .cus_Tit {
      font-size: 23px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .safetySerTit {
      font-size: 19px;
      font-weight: 500;
      /* margin: 10px 25px; */
      height: 106px;
      display: flex;
      flex-direction: column-reverse;
      margin-left: 40px;
    }
    /deep/.el-checkbox__label {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 21px;
    }
    /deep/ .el-checkbox__inner {
      width: 18px;
      height: 18px;
    }
    /deep/.el-checkbox__inner:after {
      left: 6px !important;
      top: 3px !important;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #04758e;
      border-color: #04758e;
    }
    ::v-deep .el-checkbox__inner:hover {
      border-color: #04758e;
    }
    .customBotTit {
      font-size: 24px;
      font-weight: bold;
      color: #151a23;
      margin-bottom: 40px;
    }
    //底部样式
    .customBot {
      // height: 300px;
      margin: 0 40px;
      // input去掉标签
      // /deep/ .el-input__inner {
      //   border: none;
      // }
      .userCont {
        display: flex;
        justify-content: center;
        align-content: center;
        border-bottom: 1px solid #ebebeb;
      }
      .userTit {
        width: 80px;
        display: flex;
        justify-content: left;
        align-items: center;
        height: 39px;
      }
      .submit_btn {
        background-color: #04758e;
        width: 140px;
        height: 46px;
        font-size: 16px;
        border-color: #04758e;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
